import http from "../http-common";
import authHeader from './auth-header';

class reportsService {

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// GRAPHS

  getAssetDistributionGraph(data) {
    return http.post("/graphs/asset_distribution", data, { headers: authHeader() });
  }

  getAssetPerformanceGraph(data) {
    return http.post("/graphs/asset_performance", data, { headers: authHeader() });
  }

  getFUMTopFiveGraph(data) {
    return http.post("/graphs/FUMTopFive", data, { headers: authHeader() });
  }

  getMMRatesGraph(data) {
    return http.post("/graphs/MMRates", data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MARGINS

  getTradingMargins(data) {
    return http.post("/reports/trading_margins", data, { headers: authHeader() });
  }

  getTradingMarginAllocations(data) {
    return http.post("/reports/trading_margin_allocations", data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MONEY MARKET RATES

  getMMRatesRpt(data) {
    return http.post("/reports/mm_rates_report", data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CLIENTS

  getClientLising(data) {
    return http.post("/reports/client_listing", data, { headers: authHeader() });
  }

  getClientCustodians(data) {
    return http.post("/reports/client_custodians", data, { headers: authHeader() });
  }

  getKYCReport(data) {
    return http.post("/reports/kyc", data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ACCOUNTS

  getClientFees(data) {
    return http.post("/reports/client_fees", data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DEALS

  getPendingDeals(data) {
    return http.post("/reports/pending_deals", data, { headers: authHeader() });
  }

  getSettlementReport(data) {
    return http.post("/reports/settlement_report", data, { headers: authHeader() });
  }

  getFinancialMaturityReport(data) {
    return http.post("/reports/financial_maturity_report", data, { headers: authHeader() });
  }

  getPurchaseSaleAndMaturities(data) {
    return http.post("/reports/purchase_sales&maturities", data, { headers: authHeader() });
  }

  getGeneratedEntries(data) {
    return http.post("/reports/generated_entries", data, { headers: authHeader() });
  }

  getIncomePaid(data) {
    return http.post("/reports/income_paid", data, { headers: authHeader() });
  }

  getEquitiesHoldings(data) {
    return http.post("/reports/equities_holdings", data, { headers: authHeader() });
  }

  getContributionWithdrawals(data) {
    return http.post("/reports/contributions&withdrawals", data, { headers: authHeader() });
  }

  getInterestBearingAssets(data) {
    return http.post("/reports/interest_bearing_assets", data, { headers: authHeader() });
  }

  getConsolidatedValuation(data) {
    return http.post("/reports/consolidated_valuation", data, { headers: authHeader() });
  }

  getPerformance(data) {
    return http.post("/reports/performance", data, { headers: authHeader() });
  }

  getAssetPerformance(data) {
    return http.post("/reports/asset_performance", data, { headers: authHeader() });
  }

  getIndOutstandingSettlements(data) {
    return http.post("/reports/ind_outstanding_settlements", data, { headers: authHeader() });
  }

  getAuditFunctions() {
    return http.get("/reports/audit_functions", { headers: authHeader() });
  }

  getAuditTrail(data) {
    return http.post("/reports/audit_trail", data, { headers: authHeader() });
  }

  getNMIRebate(data) {
    return http.post("/reports/nmi_rebate", data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FINANCIALS

  getPortfolioStatement(data) {
    return http.post("/reports/portfolio_statement", data, { headers: authHeader() });
  }

  getFinancialEntries(data) {
    return http.post("/reports/financial_entries", data, { headers: authHeader() });
  }

  getFinancialAccountStatement(data) {
    return http.post("/reports/financial_account_statement", data, { headers: authHeader() });
  }

  getClientValuation(data) {
    return http.post("/reports/client_valuation", data, { headers: authHeader() });
  }

  getAssetsAccrual(data) {
    return http.post("/reports/assets_accrual", data, { headers: authHeader() });
  }

  getLiabilitiesAccrual(data) {
    return http.post("/reports/liabilities_accrual", data, { headers: authHeader() });
  }

  getEquityHoldingLs(data) {
    return http.post("/reports/equity_holdingls", data, { headers: authHeader() });
  }

  getTransactionHist(data) {
    return http.post("/reports/transaction_hist", data, { headers: authHeader() });
  }

  getCounterpartyExp() {
    return http.get("/reports/counterparty_exp", { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNIT TRUSTS

  getClientFUM(data) {
    return http.post("/reports/client_fum", data, { headers: authHeader() });
  }

  getAssetExposureList(data) {
    return http.post("/reports/asset_exposure", data, { headers: authHeader() });
  }

  getUnitTrustStatement(data) {
    return http.post("/reports/ut_statement", data, { headers: authHeader() });
  }

  getUnitTrustStatementSummary(data) {
    return http.post("/reports/ut_statement_summary", data, { headers: authHeader() });
  }

  getUnitsMovement(data) {
    return http.post("/reports/units_movement", data, { headers: authHeader() });
  }

  getFundHolders(data) {
    return http.post("/reports/fund_holders", data, { headers: authHeader() });
  }
}

export default new reportsService();